import { publish, publishSync } from "pubsub-js";

import type { EventMessage } from "./types.ts";

export interface PublishEventOptions {
  async?: boolean;
}

export const publishEvent = <M extends EventMessage, T>(message: M, data?: T, { async }: PublishEventOptions = {}) => {
  // console.info(`publishEvent: ${message}`, data);
  if (async) {
    publish(message, data);
  } else {
    publishSync(message, data);
  }
};

export type PublishEvent = typeof publishEvent;
